export default {
  default: {
    container: "relative w-14 h-6 rounded-full cursor-pointer overflow-hidden",
    background:
      "absolute inset-0 flex items-center justify-between px-1 rounded-full",
    active: "bg-primary",
    inactive: "bg-text_secondary/30",
    toggle: "absolute top-0.5 left-0.5 w-5 h-5 bg-paper rounded-full shadow-md",
  },

  meet: {
    container: "relative w-11 h-6 rounded-full cursor-pointer",
    background: "absolute inset-0 rounded-full transition-colors",
    active: "bg-primary",
    inactive: "bg-neutral_2",
    toggle: "absolute top-0.5 left-0.5 w-5 h-5 bg-paper rounded-full shadow-sm",
  },

  // The Admin analog of the default variant (admin colors);
  admin: {
    container: "relative w-14 h-6 rounded-full cursor-pointer overflow-hidden",
    background:
      "absolute inset-0 flex items-center justify-between px-1 rounded-full",
    active: "bg-admin_primary",
    inactive: "bg-admin_neutral_1",
    toggle: "absolute top-0.5 left-0.5 w-5 h-5 bg-admin_paper rounded-full shadow-md",
  },
}
